import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/chaining';

/** 状況 `chaining_field`（組み立ては `../fx/chaining.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'chaining_field', role: 'effect', ...spec }, 'chaining_field_effect.js');
